const STORAGE_KEY = 'placepledge.publicPledgeTargets.v1';

const readTargets = () => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
  } catch (error) {
    console.warn('Unable to read public pledge targets:', error);
    return {};
  }
};

const writeTargets = (targets) => {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(targets));
};

const bytesToHex = (bytes) => {
  return Array.from(bytes)
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
};

export const createFulfillmentSecret = () => {
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);

  return bytesToHex(bytes);
};

export const hashFulfillmentSecret = async (secret) => {
  const data = new TextEncoder().encode(secret);
  const digest = await window.crypto.subtle.digest('SHA-256', data);

  return bytesToHex(new Uint8Array(digest));
};

export const savePublicPledgeTarget = (target) => {
  if (!target?.pledgeId) {
    throw new Error('pledgeId is required');
  }

  const targets = readTargets();
  targets[target.pledgeId] = {
    pledgeId: target.pledgeId,
    targetLat: target.targetLat,
    targetLng: target.targetLng,
    radiusFeet: target.radiusFeet,
    radiusUnit: target.radiusUnit || 'feet',
    displayLabel: target.displayLabel || 'Private destination',
    fulfillmentSecret: target.fulfillmentSecret
  };

  writeTargets(targets);
};

export const loadPublicPledgeTarget = (pledgeId) => {
  if (!pledgeId) {
    return null;
  }

  return readTargets()[pledgeId] || null;
};

export const deletePublicPledgeTarget = (pledgeId) => {
  const targets = readTargets();
  delete targets[pledgeId];
  writeTargets(targets);
};
